export default "__VITE_ASSET__fbc05fcc__"